import {
  setScheduleRebootData,
  createScheduleReboot,
  updateScheduleReboot,
  deleteScheduleReboot,
} from "stores/slice/bogus/system/scheduleReboot";

const scheduleRebootConfig = {
  "/orgs/:orgId/sites/:siteId/settings/scheduleReboot.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/scheduleReboot",
    restful: true,
    method: "read",
    buildParams: (params) => ({ data: params.data }),
    action: setScheduleRebootData,
    mockSelector: "scheduleReboot",
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/settings/scheduleReboot.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/settings/scheduleReboot",
    restful: true,
    method: "read",
    buildParams: (params) => ({ data: params.data }),
    action: setScheduleRebootData,
    mockSelector: "scheduleReboot",
  },
  "/orgs/:orgId/sites/:siteId/settings/scheduleReboot.create": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/scheduleReboot",
    restful: true,
    method: "create",
    buildParams: (params) => ({ data: params.data }),
    action: createScheduleReboot,
    mockSelector: "scheduleReboot",
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/settings/scheduleReboot.create": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/settings/scheduleReboot",
    restful: true,
    method: "create",
    buildParams: (params) => ({ data: params.data }),
    action: createScheduleReboot,
    mockSelector: "scheduleReboot",
  },
  "/orgs/:orgId/sites/:siteId/settings/scheduleReboot/:scheduleRebootId.update": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/scheduleReboot/:scheduleRebootId",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params.data }),
    action: updateScheduleReboot,
    mockSelector: "scheduleReboot",
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/settings/scheduleReboot/:scheduleRebootId.update": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/settings/scheduleReboot/:scheduleRebootId",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params.data }),
    action: updateScheduleReboot,
    mockSelector: "scheduleReboot",
  },
  "/orgs/:orgId/sites/:siteId/settings/scheduleReboot.delete": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/scheduleReboot",
    restful: true,
    method: "delete",
    buildParams: (params) => ({ data: params.data }),
    action: deleteScheduleReboot,
    mockSelector: "scheduleReboot",
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/settings/scheduleReboot.delete": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/settings/scheduleReboot",
    restful: true,
    method: "delete",
    buildParams: (params) => ({ data: params.data }),
    action: deleteScheduleReboot,
    mockSelector: "scheduleReboot",
  },
};

export default scheduleRebootConfig;
